import {
  CORE_SERVICES_HEALTH_CHECK_GROUP,
  HEALTH_CHECK_GROUPS,
} from "@/constants/health-check-groups";
import { HealthCheckName } from "@/gen_src/proto/chalk/server/v1/status_pb";
import { serviceDisplayTitle } from "@/components/settings/connection/connection.utils";

export interface DashboardConnectionHealthOption {
  id: string;
  healthChecks: HealthCheckName[];
  isGrouped: boolean;
  label: string;
}

const dashboardConnectionIdForHealthCheck = (healthCheck: HealthCheckName): string =>
  `core:${HealthCheckName[healthCheck].toLowerCase()}`;

/** The connection checks shown by the homepage overview. */
export const OVERVIEW_CONNECTION_HEALTH_CHECKS = [
  HealthCheckName.CLOUD_ACCOUNT,
  HealthCheckName.CLOUD_NETWORKING,
  HealthCheckName.HTTP_ENGINE,
  HealthCheckName.GRPC_ENGINE,
  HealthCheckName.ONLINE_STORE,
  HealthCheckName.OFFLINE_STORE,
  HealthCheckName.BRANCH_SERVER,
  HealthCheckName.STREAMING_SERVER,
] as const;

/** Canonical Connections-page order, shared by the widget renderer and its editor. */
export const DASHBOARD_CONNECTION_HEALTH_OPTIONS: readonly DashboardConnectionHealthOption[] = [
  ...CORE_SERVICES_HEALTH_CHECK_GROUP.checks.map((healthCheck) => ({
    id: dashboardConnectionIdForHealthCheck(healthCheck),
    healthChecks: [healthCheck],
    isGrouped: false,
    label: serviceDisplayTitle(healthCheck),
  })),
  ...HEALTH_CHECK_GROUPS.map(({ id, title, checks }) => ({
    id,
    healthChecks: checks,
    isGrouped: true,
    label: title,
  })),
];

export const DEFAULT_DASHBOARD_CONNECTION_HEALTH = OVERVIEW_CONNECTION_HEALTH_CHECKS.map(
  dashboardConnectionIdForHealthCheck,
);

/** Drops unknown/duplicate values and restores the Connections page's stable order. */
export const canonicalDashboardConnectionHealth = (connectionIds: readonly string[]): string[] => {
  const selected = new Set(connectionIds);
  return DASHBOARD_CONNECTION_HEALTH_OPTIONS.filter(({ id }) => selected.has(id)).map(
    ({ id }) => id,
  );
};
